import React from 'react';
import Breadcrumb from '../../../../core/layout/Breadcrumb';
import Tabs from '../../../../core/layout/Tabs';
import LearningCourseTab from './LearningCourseTab';
import LearningGlobalTab from './LearningGlobalTab';

const LearningScene = () => (
  <div>
    <Breadcrumb crumbs={[{ text: 'KPIs Learning' }]} />
    <Tabs
      tabs={[
        {
          title: 'Global',
          key: 'global',
          content: <LearningGlobalTab />,
        },
        {
          title: 'Courses',
          key: 'courses',
          content: <LearningCourseTab />,
        },
      ]}
    />
  </div>
);

export default LearningScene;
